// 应急演练
import Detail from '../components/Drill/detail.vue'
import moment from "moment";

export const preplan = [
  {title: 'ID', key: 'id', align: 'center'},
  {title: '预案名称', key: 'planCategoryName', align: 'center'},
  {title: '预案名称', key: 'planName', align: 'center'},
  {title: '预案类型', key: 'planTypeName', align: 'center'},
  {title: '地市', key: 'createDeptName', align: 'center'},
]
export const teams = [
  {title: '所属区县', key: 'unitName', align: 'center', width: 100,},
  {
    title: '职务',
    align: 'center',
    width: 100,
    render: (h, params) => {
      return h('span', {}, params.row.post === 'dz' ? '队长' : params.row.post === 'dy' ? '队员' : '')
    }
  },
  {title: '负责人', key: 'fzr', align: 'center', width: 100,},
  {
    title: '性别',
    key: 'sex',
    align: 'center',
    width: 60,
    render: (h, params) => {
      return h('span', {}, params.row.sex === '1' ? '男' : '女')
    }
  },
  {title: '电话', key: 'phone', align: 'center', width: 100, tooltip: true, ellipsis: true},
  {title: '车号', key: 'carno', align: 'center', width: 150, tooltip: true, ellipsis: true,},
  {title: '职责', key: 'duty', align: 'center', width: 300, tooltip: true, ellipsis: true},
]
export const expert = [
  {
    title: '所属区域',
    key: 'areaName',
    align: 'center',
    tooltip: true,
    ellipsis: true,
  },
  {
    title: '街道名称',
    key: 'streedName',
    align: 'center',
    tooltip: true,
    ellipsis: true,
  },
  {
    title: '专家名称',
    key: 'professionTypeName',
    align: 'center',
    tooltip: true,
    ellipsis: true,
  },
  // {
  //   title: '专家名称',
  //   align: 'center',
  //   tooltip: true,
  //   ellipsis: true,
  //   render: (h, params) => {
  //     return h('div', [
  //       h('span', params.row.storeHouse.name),
  //     ])
  //   }
  // },
  {
    title: '单位',
    align: 'center',
    tooltip: true,
    ellipsis: true,
    render: (h, params) => {
      return h('div', [
        h('span', params.row.specialist.workUnit),
      ])
    }
  },
  {
    title: '地址',
    align: 'center',
    tooltip: true,
    ellipsis: true,
    render: (h, params) => {
      return h('div', [
        h('span', params.row.specialist.address),
      ])
    }
  },
  {
    title: '备注',
    align: 'center',
    tooltip: true,
    ellipsis: true,
    render: (h, params) => {
      return h('div', [
        h('span', params.row.storeHouse.remark),
      ])
    }
  },
]
export const warehouse = [

  {
    title: '仓库名称',
    align: 'center',
    tooltip: true,
    ellipsis: true,
    render: (h, params) => {
      return h('div', [
        h('span', params.row.storeHouse.name),
      ])
    }
  },
  {
    title: '位置',
    align: 'center',
    tooltip: true,
    ellipsis: true,
    render: (h, params) => {
      return h('div', [
        h('span', params.row.storeHouse.address),
      ])
    }
  },
  {
    title: '所属区域',
    key: 'areaName',
    align: 'center',
    tooltip: true,
    ellipsis: true,
  },
  {
    title: '负责人',
    align: 'center',
    tooltip: true,
    ellipsis: true,
    render: (h, params) => {
      return h('div', [
        h('span', params.row.storeHouse.personInCharge),
      ])
    }
  },
  {
    title: '负责人电话',
    align: 'center',
    tooltip: true,
    ellipsis: true,
    render: (h, params) => {
      return h('div', [
        h('span', params.row.storeHouse.personInChargePhone),
      ])
    }
  },
  {
    title: '操作',
    align: 'center',
    width: 150,
    slot: 'action',
  }
]
export const areaList = [
  {title: 'ID', key: 'id', align: 'center', tree: true},
  {title: '区域名称', key: 'name', align: 'center'},
]
export const drillList = [
  {
    type: 'expand',
    width: 50,
    render: (h, params) => {
      return h(Detail, {
        props: {
          row: params.row
        }
      })
    }
  }, {
    title: '区县中心',
    align: 'center',
    key: 'indexCodeName'
  },
  {
    title: '演练日期',
    align: 'center',
    // width: '130',
    render: (h, params) => {
      return h('div', {}, params.row.drillDate === null ? '' : moment(params.row.drillDate).format('YYYY-MM-DD HH:mm'))
    }
  },
  {
    title: '演练地点',
    align: 'center',
    key: 'drillAddress'
  },
  {
    title: '科目',
    align: 'center',
    key: 'subjectName'
  },
  {
    title: '维护时间',
    align: 'center',
    // width: '130',
    render: (h, params) => {
      return h('div', {}, params.row.updateTime === null ? '' : moment(params.row.updateTime).format('YYYY-MM-DD HH:mm'))
    }
  },
]

export const DutyList = [
  {
    align: 'center',
    renderHeader: (h, params) => {
      return h('div', {}, moment(new Date()).format('YYYY-MM-DD'))
    },
    children: [
      {title: '区县', key: 'countyName', align: 'center'},
      {title: '值班人员', key: 'whiteDutyPersonnel', align: 'center'},
      {title: '值班电话', key: 'whiteIphone', align: 'center'},
      {title: '岗位', key: 'post', align: 'center'},
    ]
  },
]
export const materialsColumns = [
  {title: '物资名称', key: 'name', align: 'center'},
  {
    title: '数量',
    align: 'center',
    render: (h, params) => {
      return h('div', {}, params.row.number + params.row.unit)
    }
  },
  {title: '物资类型', key: 'applicableEventName', align: 'center'},
]
